<template>
  <PanelItem
    v-if="element.type === 'panel'"
    :element="element"
    :customObjectItems="customObjectItems"
  />

  <CustomObjectItem
    v-else-if="['field', 'lookup', 'button'].includes(element.type)"
    :element="element"
    :data="data"
  />

  <AlertItem v-else-if="element.type === 'alert'" :element="element" />

  <BorderItem
    v-else-if="element.type === 'border'"
    :element="element"
    :customObjectItems="customObjectItems"
  />

  <TabItem
    v-else-if="element.type === 'tab'"
    :element="element"
    :customObjectItems="customObjectItems"
  />

  <AccordionItem
    v-else-if="element.type === 'accordion'"
    :element="element"
    :customObjectItems="customObjectItems"
  />

  <div
    v-else
    :class="[
      element.type === 'container'
        ? `${element.className} ${
            !String.isNullOrWhiteSpace(element.customClasses)
              ? element.customClasses
              : ''
          }`
        : '',
    ]"
  >
    <DesignLayoutChild
      :customObjectItems="customObjectItems"
      :items="element.items"
      :data="data"
      v-if="element.container == true"
    />
  </div>
</template>

<script>
import DesignLayoutChild from "./DesignLayoutChild.vue";
import AccordionItem from "./design-items/AccordionItem.vue";
import AlertItem from "./design-items/AlertItem.vue";
import BorderItem from "./design-items/BorderItem.vue";
import CustomObjectItem from "./design-items/CustomObjectItem.vue";
import TabItem from "./design-items/TabItem.vue";
import PanelItem from "./design-items/PanelItem.vue";

export default {
  props: ["element", "index", "customObjectItems", "items", "data"],
  name: "DesignItem",
  components: {
    DesignLayoutChild,
    AccordionItem,
    AlertItem,
    BorderItem,
    CustomObjectItem,
    TabItem,
    PanelItem,
  },
  data() {
    return {
      editItem: this.element,
      editItems: [],
      childItemIndex: 0,
    };
  },
  created: function () {
    this.editItems = this.items;
    // this.childItemIndex = this.editItem?.items?.length ?? 0;
    const length = this.editItem.items == null ? 0 : this.editItem.items.length;
    this.childItemIndex = length;
  },
};
</script>
